(() => {
  'use strict';

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const setVisible = (elements, visible) => {
    elements.forEach((element) => {
      element.style.display = visible ? '' : 'none';
    });
  };

  const initializeDesktopMenu = () => {
    if (window.innerWidth < 992) return;

    document.querySelectorAll('.menu-drawer__menu details, .menu-link').forEach((item) => {
      const menu = item.querySelector('ul');
      item.addEventListener('mouseenter', () => item.setAttribute('open', ''));
      item.addEventListener('mouseleave', () => item.removeAttribute('open'));
      menu?.addEventListener('mouseleave', () => item.removeAttribute('open'));
    });

    const menuDrawer = document.querySelector('#menu-drawer');
    const menuContainer = document.querySelector('.menu-drawer-container');
    const menuIcon = document.querySelector('.header__icon--menu');

    menuDrawer?.addEventListener('click', (event) => {
      if (event.target !== menuDrawer) return;
      menuContainer?.classList.remove('menu-opening');
      menuContainer?.removeAttribute('open');
      menuIcon?.setAttribute('aria-expanded', 'false');
    });

    const mainMenuLinks = document.querySelectorAll('.main-menulink-li');
    mainMenuLinks[0]?.querySelector('.menu-drawer__submenu')?.classList.add('active');
    mainMenuLinks.forEach((menuLink) => {
      menuLink.addEventListener('mouseover', () => {
        const submenu = menuLink.querySelector('.menu-drawer__submenu');
        if (!submenu) return;
        mainMenuLinks.forEach((link) => link.querySelector('.menu-drawer__submenu')?.classList.remove('active'));
        submenu.classList.add('active');
      });
    });
  };

  const initializeStickyProductBar = () => {
    const stickyBars = document.querySelectorAll('.pdp-sticky-bar');
    if (!stickyBars.length) return;

    let ticking = false;
    const update = () => {
      const active = window.scrollY >= 700;
      stickyBars.forEach((bar) => bar.classList.toggle('active', active));
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  };

  const initializeAccordions = () => {
    document.querySelectorAll('.acc-head').forEach((heading) => {
      heading.addEventListener('click', () => {
        const content = heading.parentElement?.querySelector('.acc-content');
        const shouldOpen = !heading.classList.contains('active');

        document.querySelectorAll('.acc-head').forEach((item) => item.classList.remove('active'));
        document.querySelectorAll('.acc-content').forEach((item) => {
          item.style.display = 'none';
        });

        if (shouldOpen && content) {
          heading.classList.add('active');
          content.style.display = 'block';
        }
      });
    });
  };

  const initializeTabs = () => {
    document.querySelectorAll('.tab').forEach((tab) => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.tabs .tab').forEach((item) => item.classList.remove('active'));
        document.querySelectorAll('.tab-content').forEach((item) => item.classList.remove('active'));
        tab.classList.add('active');

        const target = tab.getAttribute('data-toggle-target');
        if (!target) return;
        try {
          document.querySelectorAll(target).forEach((item) => item.classList.add('active'));
        } catch (error) {
          console.warn('Invalid tab target:', target, error);
        }
      });
    });
  };

  const initializeReviewScrollbar = () => {
    const scrollable = document.querySelector('#scrollableDiv');
    const range = document.querySelector('#scrollRange');
    if (!scrollable || !range) return;

    scrollable.addEventListener('scroll', () => {
      const maxScroll = scrollable.scrollHeight - scrollable.clientHeight;
      range.value = maxScroll > 0 ? (scrollable.scrollTop / maxScroll) * 100 : 0;
    }, { passive: true });

    range.addEventListener('input', () => {
      const maxScroll = scrollable.scrollHeight - scrollable.clientHeight;
      scrollable.scrollTop = (maxScroll * Number(range.value)) / 100;
    });
  };

  const initializeSliders = () => {
    if (typeof window.Swiper !== 'function') return;

    const a11y = () => ({
      enabled: true,
      prevSlideMessage: window.sliderStrings?.previousSlide || 'Previous slide',
      nextSlideMessage: window.sliderStrings?.nextSlide || 'Next slide',
      paginationBulletMessage: (window.sliderStrings?.goToSlide || 'Go to slide [index]').replace('[index]', '{{index}}'),
    });

    const createSlider = (selector, options) => {
      if (document.querySelector(selector)) new window.Swiper(selector, options);
    };

    createSlider('.announcement-bar-slider', {
      a11y: a11y(),
      loop: true,
      slidesPerView: 1,
      autoplay: { delay: 5000 },
      paginationClickable: true,
      spaceBetween: 0,
      navigation: { nextEl: '.announcement-next', prevEl: '.announcement-prev' },
    });

    createSlider('.home-banner-slider', {
      a11y: a11y(),
      loop: true,
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 0,
      navigation: { nextEl: '.home-next', prevEl: '.home-prev' },
    });

    if (window.innerWidth < 991) {
      createSlider('.icon-section-slider', {
        a11y: a11y(),
        slidesPerView: 1,
        spaceBetween: 14,
        pagination: { el: '.icon-section-pagination', clickable: true },
      });
      createSlider('.template-product .featured-collection-slider', {
        a11y: a11y(),
        spaceBetween: 14,
        navigation: { nextEl: '.collection-next', prevEl: '.collection-prev' },
        breakpoints: { 320: { slidesPerView: 1 }, 767: { slidesPerView: 2 } },
      });
      createSlider('.logo-sec-slider-mob', {
        a11y: a11y(),
        slidesPerView: 2,
        spaceBetween: 14,
        pagination: { el: '.icon-section-pagination', clickable: true },
      });
    } else {
      createSlider('.template-index .featured-collection-slider', {
        a11y: a11y(),
        spaceBetween: 14,
        navigation: { nextEl: '.collection-next', prevEl: '.collection-prev' },
        breakpoints: { 767: { slidesPerView: 3 }, 991: { slidesPerView: 4 } },
      });
    }

    createSlider('.logo-sec-slider', {
      a11y: a11y(),
      slidesPerView: 2,
      spaceBetween: 28,
      pagination: { el: '.icon-section-pagination', clickable: true },
      breakpoints: { 320: { slidesPerView: 2 }, 767: { slidesPerView: 2 }, 991: { slidesPerView: 6 } },
    });

    createSlider('.feature-blog-slider', {
      a11y: a11y(),
      slidesPerView: 3,
      spaceBetween: 14,
      pagination: { el: '.feature-blog-pagination', clickable: true },
      navigation: { nextEl: '.blog-next', prevEl: '.blog-prev' },
      breakpoints: { 320: { slidesPerView: 1 }, 767: { slidesPerView: 2 }, 991: { slidesPerView: 3 } },
    });

    createSlider('.condition-image-slider', {
      a11y: a11y(),
      slidesPerView: 1,
      navigation: { nextEl: '.cus-next', prevEl: '.cus-prev' },
    });
  };

  const initializeCollectionView = () => {
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;

    document.querySelector('.pro-item.grid-product')?.addEventListener('click', () => {
      const mobileColumns = productGrid.getAttribute('data-col_mobile');
      const desktopColumns = productGrid.getAttribute('data-col_desk');
      productGrid.className = `grid product-grid grid--${mobileColumns}-col-tablet-down grid--${desktopColumns}-col-desktop grid-products`;
    });

    document.querySelector('.pro-item.list-product')?.addEventListener('click', () => {
      productGrid.className = 'grid product-grid grid--1-col-tablet-down grid--1-col-desktop list-products';
    });
  };

  const initializeProductControls = () => {
    document.querySelectorAll('.pdp-bar-btn .button').forEach((button) => {
      button.addEventListener('click', () => document.querySelector('.product-form .product-form__submit')?.click());
    });

    document.querySelectorAll('.switch-cus input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        setVisible(document.querySelectorAll('#product__text-text_NDdEhw'), !checkbox.checked);
        setVisible(document.querySelectorAll('.selected_vari'), checkbox.checked);
        setVisible(document.querySelectorAll('.product__info-container .price__container'), checkbox.checked);
      });
    });
  };

  const initializeMenuClose = () => {
    document.querySelectorAll('.menu-drawer-head .icon-close').forEach((button) => {
      button.addEventListener('click', () => document.querySelector('.header__icon--menu')?.click());
    });
  };

  const initializeAnnouncementCookie = () => {
    const popup = document.querySelector('.announcement-bar-popup');
    const bar = document.querySelector('.m-bar.m-red');
    if (!popup && !bar) return;

    const getCookie = (name) => document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1] || null;

    const setCookie = (name, value, days) => {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
    };

    document.querySelectorAll('.m-close').forEach((button) => {
      button.addEventListener('click', () => {
        setCookie('cookie_anno', '1', 7);
        if (popup) popup.style.display = 'none';
        bar?.classList.remove('hidden');
      });
    });

    if (getCookie('cookie_anno')) {
      if (popup) popup.style.display = 'none';
      bar?.classList.add('hidden');
    } else {
      if (popup) popup.style.display = 'block';
      bar?.classList.remove('hidden');
    }
  };

  onReady(() => {
    initializeDesktopMenu();
    initializeStickyProductBar();
    initializeAccordions();
    initializeTabs();
    initializeReviewScrollbar();
    initializeMenuClose();
    initializeSliders();
    initializeCollectionView();
    initializeProductControls();
    initializeAnnouncementCookie();
  });
})();
